var other = {
    mmToPixelConversion: function(){
        var mm = $('#from_mm').val();
        $('#to_pixel').val(mm * 0.15 * 0.75);
    },
    pixelToMMConversion: function(){
        var pixel = $('#from_pixel').val();
        $('#to_mm').val(pixel / 0.15 * 0.75);
    },
};